import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Methodology from './components/Methodology';
import PassiveGrowth from './components/PassiveGrowth';
import Testimonials from './components/Testimonials';
import BusinessGrowth from './components/BusinessGrowth';
import StartupCoaching from './components/StartupCoaching';
import ServiceCallouts from './components/ServiceCallouts';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import About from './pages/About';
import Retirement from './pages/Retirement';
import Portfolio from './pages/Portfolio';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <Methodology />
      <PassiveGrowth />
      <Testimonials />
      <BusinessGrowth />
      <StartupCoaching />
      <ServiceCallouts />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/retirement" element={<Retirement />} />
          <Route path="/our-builds" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
